(()=>{const root=document.querySelector('[data-module-hub]');if(!root)return;const input=root.querySelector('#hub-search'),buttons=[...root.querySelectorAll('[data-hub-filter]')],cards=[...root.querySelectorAll('.hub-card')],count=root.querySelector('#hub-result-count'),empty=root.querySelector('#hub-empty');let group='all';function filter(){const terms=input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);let shown=0;for(const card of cards){const match=(group==='all'||card.dataset.group===group)&&terms.every(t=>card.dataset.search.includes(t));card.hidden=!match;if(match)shown++;}count.textContent=`${shown} of ${cards.length} practice areas`;empty.hidden=shown>0;}function setGroup(value){group=value;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.hubFilter===value)));filter();}buttons.forEach(b=>b.addEventListener('click',()=>setGroup(b.dataset.hubFilter)));input.addEventListener('input',filter);root.querySelector('[data-hub-reset]').addEventListener('click',()=>{input.value='';setGroup('all');input.focus();});root.querySelectorAll('[data-hub-jump]').forEach(a=>a.addEventListener('click',()=>{input.value='';setGroup(a.dataset.hubJump);}));filter();})();

/* Preserve the live-status pulse while visible; pause unused offscreen work. */
(() => {
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-module-hub]')];
    if (scope.matches?.('[data-module-hub]')) roots.push(scope);
    roots.forEach(root => {
      const map = root.querySelector('.hub-map');
      if (!map || map._erpHubMotion) return;
      let visible = !('IntersectionObserver' in window);
      function sync() {
        map.toggleAttribute('data-hub-motion-paused', document.hidden || !visible);
      }
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          visible = entry.isIntersecting;
          sync();
        });
      }, { rootMargin: '80px 0px', threshold: 0 }) : null;
      function unload(event) {
        if (event.target !== root && !event.target.contains(root)) return;
        observer?.disconnect();
        document.removeEventListener('visibilitychange', sync);
        document.removeEventListener('shopify:section:unload', unload);
        map.removeAttribute('data-hub-motion-paused');
        delete map._erpHubMotion;
      }
      map._erpHubMotion = { unload };
      document.addEventListener('visibilitychange', sync);
      document.addEventListener('shopify:section:unload', unload);
      observer?.observe(map);
      sync();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
